import type { CarStatus, CostType, Currency, Drive, Fuel, Gearbox, TextLength } from './enums';

/** Status names in the Mini App (chips, filters, forms). */
export const STATUS_LABEL: Record<CarStatus, string> = {
  in_transit: 'В дорозі',
  customs: 'Розмитнення',
  available: 'В наявності',
  reserved: 'Бронь',
  sold: 'Продано',
  archived: 'Архів',
};

export const COST_TYPE_LABEL: Record<CostType, string> = {
  purchase: 'Закупівля',
  delivery: 'Доставка',
  customs: 'Розмитнення',
  repair: 'Ремонт',
  certification: 'Сертифікація',
  other: 'Інше',
};

export const CURRENCY_LABEL: Record<Currency, string> = {
  USD: 'USD, $',
  EUR: 'EUR, €',
  UAH: 'UAH, грн',
};

export const FUEL_LABEL: Record<Fuel, string> = {
  petrol: 'бензин',
  diesel: 'дизель',
  lpg: 'газ/бензин',
  hybrid: 'гібрид',
  plugin_hybrid: 'плагін-гібрид',
  electric: 'електро',
};

export const GEARBOX_LABEL: Record<Gearbox, string> = {
  automatic: 'автомат',
  manual: 'механіка',
  robot: 'робот',
  cvt: 'варіатор',
};

export const DRIVE_LABEL: Record<Drive, string> = {
  fwd: 'передній привід',
  rwd: 'задній привід',
  awd: 'повний привід',
};

export const TEXT_LENGTH_LABEL: Record<TextLength, string> = {
  short: 'Коротко',
  standard: 'Стандарт',
  detailed: 'Детально',
};
